module.exports = __webpack_public_path__ + "img/filter-white.24b53dac.svg";